<template>
    <div class="pdf1_main">
        <main>
            <div class="tableHeader">
                <p><span v-if="v_lan == 'ch'">{{ $t("pdf.text48") }}</span><span>{{ lang_en.pdf.text48 }}</span></p>
            </div>
            <div class="body-table">
                <table>
                    <tr class="advice-tr">
                        <th class="tr-label">
                            <span v-if="v_lan == 'ch'">{{ $t("pdf.text20") }}</span><span>{{ lang_en.pdf.text20 }}</span>
                        </th>
                        <th class="tr-des">: {{ days }}-{{ m | current_month }}-{{y}}</th>
                    </tr>
                    <!-- 存入 -->
                    <template v-if="dataList.type == 1">
                        <tr class="advice-tr">
                            <th class="tr-label">
                                <span v-if="v_lan == 'ch'">{{ $t("pdf.text22") }}</span><span>{{ lang_en.pdf.text22 }}</span>
                            </th>
                            <th class="tr-des">: {{ dataList.tx_id }}</th>
                        </tr>
                        <tr class="advice-tr" v-if="dataList.tx_type == 2">
                            <th class="tr-label">
                                <span v-if="v_lan == 'ch'">{{ $t("pdf.text64") }}</span><span>{{ lang_en.pdf.text64 }}</span>
                            </th>
                            <th class="tr-des">: {{ dataList.sender_name }}</th>
                        </tr>
                        <tr class="advice-tr">
                            <th class="tr-label">
                                <span v-if="v_lan == 'ch'">{{ $t("pdf.text65") }}</span><span>{{ lang_en.pdf.text65 }}</span>
                            </th>
                            <th class="tr-des">: {{ dataList.sender_wallet_address }}</th>
                        </tr>
                        <tr class="advice-tr">
                            <th class="tr-label">
                                <span v-if="v_lan == 'ch'">{{ $t("pdf.text76") }}</span><span>{{ lang_en.pdf.text76 }}</span>
                            </th>
                            <th class="tr-des">: {{ dataList.tx_hash }}</th>
                        </tr>
                    </template>
                    <!-- 转账 -->
                    <template v-if="dataList.type == 2 || dataList.type == 10  || dataList.type == 11">
                        <tr class="advice-tr" v-if="dataList.tx_type == 2">
                            <th class="tr-label">
                                <span v-if="v_lan == 'ch'">{{ $t("pdf.text22") }}</span><span>{{ lang_en.pdf.text22 }}</span>
                            </th>
                            <th class="tr-des">: {{ dataList.tx_id }}</th>
                        </tr>
                        <tr class="advice-tr">
                            <th class="tr-label">
                                <span v-if="v_lan == 'ch'">{{ $t("main.text348") }}</span><span>{{ lang_en.main.text348 }}</span>
                            </th>
                            <th class="tr-des">: {{ dataList.beneficiary_name }}</th>
                        </tr>
                        <!-- 加密货币 -->
                        <template v-if="dataList.tx_type == 1">
                            <tr class="advice-tr">
                                <th class="tr-label">
                                    <span v-if="v_lan == 'ch'">{{ $t("main.text342") }}</span><span>{{ lang_en.main.text342 }}</span>
                                </th>
                                <th class="tr-des">: {{ dataList.wallet_address }}</th>
                            </tr>
                            <tr class="advice-tr">
                                <th class="tr-label">
                                    <span v-if="v_lan == 'ch'">{{ $t("pdf.text57") }}</span><span>{{ lang_en.pdf.text57 }}</span>
                                </th>
                                <th class="tr-des">: {{ dataList.network_type }}</th>
                            </tr>
                            <tr class="advice-tr">
                                <th class="tr-label">
                                    <span v-if="v_lan == 'ch'">{{ $t("pdf.text76") }}</span><span>{{ lang_en.pdf.text76 }}</span>
                                </th>
                                <th class="tr-des">: {{ dataList.tx_hash }}</th>
                            </tr>
                        </template>
                        <!-- 法币 -->
                        <template v-if="dataList.tx_type == 2">
                            <tr class="advice-tr">
                                <th class="tr-label">
                                    <span v-if="v_lan == 'ch'">{{ $t("pdf.text61") }}</span><span>{{ lang_en.pdf.text61 }}</span>
                                </th>
                                <th class="tr-des">: {{ dataList.bank_account_number }}</th>
                            </tr>
                            <tr class="advice-tr">
                                <th class="tr-label">
                                    <span v-if="v_lan == 'ch'">{{ $t("pdf.text62") }}</span><span>{{ lang_en.pdf.text62 }}</span>
                                </th>
                                <th class="tr-des">: {{ dataList.bank_account_name }}</th>
                            </tr>
                            <tr class="advice-tr">
                                <th class="tr-label">
                                    <span v-if="v_lan == 'ch'">{{ $t("pdf.text63") }}</span><span>{{ lang_en.pdf.text63 }}</span>
                                </th>
                                <th class="tr-des">: {{ dataList.bank_swift_code }}</th>
                            </tr>
                            <tr class="advice-tr">
                                <th class="tr-label">
                                    <span v-if="v_lan == 'ch'">{{ $t("pdf.text76") }}</span><span>{{ lang_en.pdf.text76 }}</span>
                                </th>
                                <th class="tr-des">: {{ dataList.tx_hash }}</th>
                            </tr>
                        </template>
                    </template>
                    <!-- 充值 年费 -->
                    <template v-if="dataList.type == 3 || dataList.type == 12 || dataList.type == 4 || dataList.type == 5 || dataList.type == 6 || dataList.type == 9 || dataList.type == 13 || dataList.type == 14 || dataList.type == 15 || dataList.type == 16 || dataList.type == 17 || dataList.type == 18 || dataList.type == 19 || dataList.type == 20 || dataList.type == 21 || dataList.type == 22 || dataList.type == 23">
                        <tr class="advice-tr">
                            <th class="tr-label">
                                <span v-if="v_lan == 'ch'">{{ $t("pdf.text22") }}</span><span>{{ lang_en.pdf.text22 }}</span>
                            </th>
                            <th class="tr-des">: {{ dataList.tx_id }}</th>
                        </tr>
                        <tr class="advice-tr">
                            <th class="tr-label">
                                <span v-if="v_lan == 'ch'">{{ $t("main.text348") }}</span><span>{{ lang_en.main.text348 }}</span>
                            </th>
                            <th class="tr-des">: {{ dataList.beneficiary_name }}</th>
                        </tr> 
                    </template>
                    <!-- 退还年费 退还注册费 -->
                    <template v-if="dataList.type == 7 || dataList.type == 8|| dataList.type == 24|| dataList.type == 25|| dataList.type == 26|| dataList.type == 27|| dataList.type == 28|| dataList.type == 29|| dataList.type == 30">
                        <tr class="advice-tr">
                            <th class="tr-label">
                                <span v-if="v_lan == 'ch'">{{ $t("pdf.text22") }}</span><span>{{ lang_en.pdf.text22 }}</span>
                            </th>
                            <th class="tr-des">: {{ dataList.tx_id }}</th>
                        </tr>
                        <tr class="advice-tr" v-if="[26,27,28,29].includes(dataList.type) ">
                            <th class="tr-label">
                                <span v-if="v_lan == 'ch'">{{ $t("main.text348") }}</span><span>{{ lang_en.main.text348 }}</span>
                            </th>
                            <th class="tr-des">: {{ dataList.beneficiary_name }}</th>
                        </tr>
                        <tr class="advice-tr" v-else>
                            <th class="tr-label">
                                <span v-if="v_lan == 'ch'">{{ $t("pdf.text64") }}</span><span>{{ lang_en.pdf.text64 }}</span>
                            </th>
                            <!-- <th class="tr-des">: {{ dataList.sender_name }}</th> -->
                            <th class="tr-des">: {{ dataList.beneficiary_name }}</th>
                        </tr>
                    </template>
                </table>
            </div>
           
            <div class="pdf_header">
                <p><span v-if="v_lan == 'ch'">{{ $t("pdf.text49") }} </span>{{ lang_en.pdf.text49 }}</p>
            </div>
            <table>
            	<!-- 表头 -->
                <tr class="tr">
                    <th>
                        <p v-if="v_lan == 'ch'">{{ $t("pdf.text21") }}</p>
                        <p>{{ lang_en.pdf.text21 }}</p>
                    </th>
                    <th>
                        <p v-if="v_lan == 'ch'">{{ $t("pdf.text50") }}</p>
                        <p>{{ lang_en.pdf.text50 }}</p>
                        <p>{{ dataList.to_token_type }}</p>
                    </th>
                    <th>
                        <p v-if="v_lan == 'ch'">{{ $t("pdf.text51") }}</p>
                        <p>{{ lang_en.pdf.text51 }}</p>
                    </th>
                    <template v-if="dataList.type == 1 || dataList.type == 7 || dataList.type == 8 || dataList.type == 13|| dataList.type == 22 || dataList.type == 24|| dataList.type == 25|| dataList.type == 27|| dataList.type == 30">
                    	<th>
	                        <p v-if="v_lan == 'ch'">{{ $t("pdf.text60") }}</p>
	                        <p>{{ lang_en.pdf.text60 }}</p>
                    		<p>{{ dataList.token_type }}</p>
	                    </th>
                    </template>
                    <template v-if="dataList.type == 2 || dataList.type == 10  || dataList.type == 11 || dataList.type == 3 || dataList.type == 12 || dataList.type == 4 || dataList.type == 5 || dataList.type == 6 || dataList.type == 9 || dataList.type == 14 || dataList.type == 15 || dataList.type == 16 || dataList.type == 17 || dataList.type == 18 || dataList.type == 19 || dataList.type == 20 || dataList.type == 21 || dataList.type == 23|| dataList.type == 26|| dataList.type == 28|| dataList.type == 29" >
                    	<th>
	                        <p v-if="v_lan == 'ch'">{{ $t("pdf.text52") }}</p>
	                        <p>{{ lang_en.pdf.text52 }}</p>
                            <p>{{ dataList.token_type }}</p>
	                        
	                    </th>
                    </template>
                    <th>
                        <p v-if="v_lan == 'ch'">{{ $t("pdf.text53") }}</p>
                        <p>{{ lang_en.pdf.text53 }}</p>
                    </th>
                </tr>
                <!-- 数据 -->
                <template v-if="dataList.type == 1">
                	<tr>
                        <td>
                        	<p v-if="v_lan == 'ch'">{{ $t("pdf.text54") }}</p>
                        	<p>{{ lang_en.pdf.text54 }}</p>
                        </td>
                        <td>{{ dataList.remittance_amount == '-' ? dataList.remittance_amount : set_num3(dataList.remittance_amount) }}</td>
                        <td>{{ dataList.exchange_rate }}</td>
                        <td>{{ dataList.amount == '-' ? dataList.amount : set_num3(dataList.amount) }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                </template>
                <template v-if="dataList.type == 2 || dataList.type == 10  || dataList.type == 11">
                    <tr>
                        <td>
                        	<p v-if="v_lan == 'ch'">{{ $t("pdf.text54") }}</p>
                        	<p>{{ lang_en.pdf.text54 }}</p>
                        </td>
                        <td>{{ dataList.remittance_amount == '-' ? dataList.remittance_amount : set_num3(dataList.remittance_amount) }}</td>
                        <td>{{ dataList.exchange_rate }}</td>
                        <td>{{ dataList.amount == '-' ? dataList.amount : set_num3(dataList.amount) }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                    <tr>
                        <td>
                        	<p v-if="v_lan == 'ch'">{{ $t("pdf.text55") }}</p>
                        	<p>{{ lang_en.pdf.text55 }}</p>
                        </td>
                        <td></td>
                        <td></td>
                        <td>{{ dataList.fixed_fee }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                    <tr>
                        <td>
                        	<p v-if="v_lan == 'ch'">{{ $t("pdf.text56") }}</p>
                        	<p>{{ lang_en.pdf.text56 }}</p>
                        </td>
                        <td></td>
                        <td></td>
                        <td>{{ dataList.fee }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                </template>
                <template v-if="dataList.type == 3 || dataList.type == 12">
                	<tr>
                        <td>
                        	<p v-if="v_lan == 'ch'">{{ $t("pdf.text66") }}</p>
                        	<p>{{ lang_en.pdf.text66 }}</p>
                        </td>
                        <td>{{ dataList.remittance_amount == '-' ? dataList.remittance_amount : set_num3(dataList.remittance_amount) }}</td>
                        <td>{{ dataList.exchange_rate }}</td>
                        <td>{{ dataList.amount == '-' ? dataList.amount : set_num3(dataList.amount) }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                    <tr>
                        <td>
                        	<p v-if="v_lan == 'ch'">{{ $t("pdf.text67") }}</p>
                        	<p>{{ lang_en.pdf.text67 }}</p>
                        </td>
                        <td></td>
                        <td></td>
                        <td>{{ dataList.fee }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                </template>
                <template v-if="dataList.type == 4">
                	<tr>
                        <td>
                        	<p v-if="v_lan == 'ch'">{{ $t("pdf.text68") }}</p>
                        	<p>{{ lang_en.pdf.text68 }}</p>
                        </td>
                        <td>{{ dataList.remittance_amount == '-' ? dataList.remittance_amount : set_num3(dataList.remittance_amount) }}</td>
                        <td>{{ dataList.exchange_rate }}</td>
                        <td>{{ dataList.amount == '-' ? dataList.amount : set_num3(dataList.amount) }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                </template>
                <template v-if="dataList.type == 5">
                	<tr>
                        <td>
                        	<p v-if="v_lan == 'ch'">{{ $t("pdf.text69") }}</p>
                        	<p>{{ lang_en.pdf.text69 }}</p>
                        </td>
                        <td>{{ dataList.remittance_amount == '-' ? dataList.remittance_amount : set_num3(dataList.remittance_amount) }}</td>
                        <td>{{ dataList.exchange_rate }}</td>
                        <td>{{ dataList.amount == '-' ? dataList.amount : set_num3(dataList.amount) }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                </template>
                <template v-if="dataList.type == 6">
                	<tr>
                        <td>
                        	<p v-if="v_lan == 'ch'">{{ $t("pdf.text70") }}</p>
                        	<p>{{ lang_en.pdf.text70 }}</p>
                        </td>
                        <td>{{ dataList.remittance_amount == '-' ? dataList.remittance_amount : set_num3(dataList.remittance_amount) }}</td>
                        <td>{{ dataList.exchange_rate }}</td>
                        <td>{{ dataList.amount == '-' ? dataList.amount : set_num3(dataList.amount) }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                </template>
                <template v-if="dataList.type == 7">
                	<tr>
                        <td>
                        	<p v-if="v_lan == 'ch'">{{ $t("pdf.text71") }}</p>
                        	<p>{{ lang_en.pdf.text71 }}</p>
                        </td>
                        <td>{{ dataList.remittance_amount == '-' ? dataList.remittance_amount : set_num3(dataList.remittance_amount) }}</td>
                        <td>{{ dataList.exchange_rate }}</td>
                        <td>{{ dataList.amount == '-' ? dataList.amount : set_num3(dataList.amount) }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                </template>
                <template v-if="dataList.type == 8">
                	<tr>
                        <td>
                        	<p v-if="v_lan == 'ch'">{{ $t("pdf.text72") }}</p>
                        	<p>{{ lang_en.pdf.text72 }}</p>
                        </td>
                        <td>{{ dataList.remittance_amount == '-' ? dataList.remittance_amount : set_num3(dataList.remittance_amount) }}</td>
                        <td>{{ dataList.exchange_rate }}</td>
                        <td>{{ dataList.amount == '-' ? dataList.amount : set_num3(dataList.amount) }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                </template>
                <template v-if="dataList.type == 9">
                    <tr>
                        <td>
                            <p v-if="v_lan == 'ch'">{{ $t("pdf.text73") }}</p>
                            <p>{{ lang_en.pdf.text73 }}</p>
                        </td>
                        <td>{{ dataList.remittance_amount == '-' ? dataList.remittance_amount : set_num3(dataList.remittance_amount) }}</td>
                        <td>{{ dataList.exchange_rate }}</td>
                        <td>{{ dataList.amount == '-' ? dataList.amount : set_num3(dataList.amount) }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                </template>
                <template v-if="dataList.type == 13">
                    <tr>
                        <td>
                            <p v-if="v_lan == 'ch'">{{ $t("pdf.text74") }}</p>
                            <p>{{ lang_en.pdf.text74 }}</p>
                        </td>
                        <td>{{ dataList.remittance_amount == '-' ? dataList.remittance_amount : set_num3(dataList.remittance_amount) }}</td>
                        <td>{{ dataList.exchange_rate }}</td>
                        <td>{{ dataList.amount == '-' ? dataList.amount : set_num3(dataList.amount) }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                </template>
                <template v-if="dataList.type == 14">
                    <tr>
                        <td>
                            <p v-if="v_lan == 'ch'">{{ $t("pdf.text75") }}</p>
                            <p>{{ lang_en.pdf.text75 }}</p>
                        </td>
                        <td>{{ dataList.remittance_amount == '-' ? dataList.remittance_amount : set_num3(dataList.remittance_amount) }}</td>
                        <td>{{ dataList.exchange_rate }}</td>
                        <td>{{ dataList.amount == '-' ? dataList.amount : set_num3(dataList.amount) }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                </template>
                <template v-if="dataList.type == 15">
                    <tr>
                        <td>
                            <p v-if="v_lan == 'ch'">{{ $t("pdf.text77") }}</p>
                            <p>{{ lang_en.pdf.text77 }}</p>
                        </td>
                        <td>{{ dataList.remittance_amount == '-' ? dataList.remittance_amount : set_num3(dataList.remittance_amount) }}</td>
                        <td>{{ dataList.exchange_rate }}</td>
                        <td>{{ dataList.amount == '-' ? dataList.amount : set_num3(dataList.amount) }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                </template>
                
                <template v-if="[16,17,18,19,20,21,22,23,24,25,26,27,28,29,30].includes(dataList.type)">
                    <tr>
                        <td style="min-width: 230px;" v-html="dataList.type_name"></td>
                        <td>{{ dataList.remittance_amount == '-' ? dataList.remittance_amount : set_num3(dataList.remittance_amount) }}</td>
                        <td>{{ dataList.exchange_rate }}</td>
                        <td>{{ dataList.amount == '-' ? dataList.amount : set_num3(dataList.amount) }}</td>
                        <td>{{ dataList.account_number }}</td>
                    </tr>
                </template>
                

            </table>
            <div class="pdf_payment">
            	<div class="pdf_payment_title">
            		<span>{{ $t("pdf.text58") }} </span>
            		<span v-if="v_lan == 'ch'">{{ lang_en.pdf.text58 }}</span>
            	</div>
            	<div class="pdf_payment_des">
            		{{  dataList.remark }}
            	</div>
            </div>
        </main>
    </div>
</template>
<script>
import lang_en from "@/language/en";

export default {
    filters: {
        current_month(v) {
            let en_mon_arr = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ];
            return en_mon_arr[v - 1];
        },
    },
    props: {
        dataList: {
            default: {},
        },
        y: {
            default: "",
        },
        m: {
            default: "",
        },
        days: {
            default: "",
        },
    },
    data() {
        return {
            lang_en: lang_en,
        };
    },
    mounted() {

    },
    methods: {},
};
</script>
<style scoped lang="less">
/* a4纸的尺寸[595.28,841.89] */
h5 {
    font-size: 22px;
}

h6 {
    font-size: 18px;
}

.pdf1_main {
    font-size: 14px;
    // transform: scale(0.5);
    width: 595.28 * 2;
    margin: 0 30px 10px 30px;
    padding-bottom: 20px;

    .headerLogo {
        display: flex;
        justify-content: flex-end;

        img {
            width: 100px;
            margin-bottom: 30px;
        }
    }

    main {
        margin-top: 20px;

        .tableHeader {
            margin-top: 20px;
            background: #00263a;
            border-radius: 10px;
            display: flex;
            justify-content: space-between;
            width: 100%;
            color: white;
            font-weight: bold;
            align-items: center;

            p {
                margin-top: 5px;
                margin-bottom: 5px;
                margin-left: 8px;
                font-size: 14px;
                font-weight: 500;
                color: #FFFFFF;

                span {
                    margin-right: 5px;
                }
            }
        }

        table {
            width: 100%;
            border-collapse: collapse;

            .tr {
                background: #D0D3D4;
            }

            .tr th {
                // border-bottom: 1px solid #000;
                padding: 5px 5px 8px 5px;
                text-align: right;
                width: 18%;
                vertical-align: text-bottom;
            }

            tr td {
                text-align: right;
                width: 18%;
                font-weight: 300;
                font-family: Outfit-Light;

                p {
                	font-family: Outfit-Light;
                }
            }

            tr td,
            tr h6 {
                padding: 5px;
                font-size: 14px;
            }

            tr td:nth-child(1) {
                text-align: left;
                width: 28%;
            }

            tr th:nth-child(1) {
                text-align: left;
                width: 28%;
            }

            .footer_tr td {
                padding-top: 20px;
            }
        }

        .pdf_header {
            margin-top: 36px;
            margin-bottom: 16px;
            font-weight: 500;
            color: #010101;
        }

        .pdf_payment {
            margin-top: 12px;
            border-top: 1px solid #000000;
        	border-bottom: 1px solid #000000;
        	padding-top: 12px;
        	padding-bottom: 24px;
        	padding-left: 8px;

        	.pdf_payment_des {
        		margin-top: 24px;
        		font-family: "Outfit-Light";
                font-weight: 300;
        	}
        }
    }
}

.ad_body {
    padding-top: 16px;
    padding-left: 8px;
    padding-bottom: 24px;
    border-bottom: 1px solid #000;

    .item {
        // display: flex;
        // align-items: center;
        margin-bottom: 4px;

        .item-label {
            width: 270px;
            display: inline-block;

            span {
                margin-right: 5px;
            }
        }

        .item-des {
            font-family: "Outfit-Light";
            font-weight: 300;
            display: inline-block;
        }
    }
}
.body-table {
    padding-top: 16px;
    padding-left: 8px;
    padding-bottom: 24px;
    border-bottom: 1px solid #000;

    table {
        width: 100%;
        border-collapse: collapse;

        .advice-tr {
            height: 24px;
            
            .tr-label {
                width: 270px;
                display: inline-block;

                span {
                    font-weight: 400;
                    margin-right: 5px;
                }
            }
        }


        .advice-tr .tr-des {
            width: calc(100% - 280px);
            text-align: left;
            font-family: "Outfit-Light";
            font-weight: 300;
            display: inline-block;
        }
    }
}
</style>